import { v4 as newUuid } from 'uuid';
import Firebase from '../../services/firebase';

export function FormataTelefone(v) {
  let r = v.replace(/\D/g, '');
  r = r.replace(/^0/, '');
  if (r.length > 10) {
    r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2$3');
  } else if (r.length > 5) {
    r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2$3');
  } else if (r.length > 2) {
    r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
  } else {
    r = r.replace(/^(\d*)/, '($1');
  }
  return r.length === 1 ? '' : r;
}

export function DataAtual() {
  const data = new Date();
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const ano = data.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function InverterDataAtualUS(props) {
  const data = props.toString();
  const ano = String(data.substring(0, 4)).padStart(2, '0');
  const mes = String(data.substring(5, 7)).padStart(2, '0');
  const dia = String(data.substring(8));
  return `${dia}/${mes}/${ano}`;
}

export function ConvertStringToDate(props) {
  const data = props;
  const arrData = data.split('/');
  const stringFormatada = `${arrData[1]}-${arrData[0]}-${arrData[2]}`;
  const dataFormatada = new Date(stringFormatada);
  return dataFormatada;
}

export function CalcularDistancia({
  lat1, lon1, lat2, lon2,
}) {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
  + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2
    * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return Math.round(d * 1000);
}

export function NotificarNaPlataforma({ uidEnviar, mensagemEnviar }) {
  const db = Firebase.firestore();
  db.collection('users').doc(uidEnviar).get().then((doc) => {
    const nowUsuario = doc.data();
    const { notifications } = nowUsuario;
    const novoUid = newUuid();
    const novaMsgm = {
      [`${novoUid}`]: {
        body: mensagemEnviar,
        title: 'Mensagem de AGSAFE',
        data: DataAtual(),
        read: false,
        uid: novoUid,
      },
    };
    Firebase.firestore().collection('users').doc(uidEnviar).update(
      {
        ...nowUsuario,
        notifications: [
          ...notifications, novaMsgm,
        ],
      },
    )
      .then(() => {

      });
  });
}
